import { createSlice } from '@reduxjs/toolkit'

interface AuthSlice {
  token?: string
}

const authSlice = createSlice({
  name: 'auth',
  initialState: {} as AuthSlice,
  reducers: {
    signedIn: (state, action) => {
      state.token = action.payload
    },
    signedOut: (state) => {
      state.token = undefined
    },
  },
})


export default authSlice.reducer
export const { signedIn, signedOut } = authSlice.actions
